import StyledText from "../components/StyledComponents/StyledText";
import SuccessIcon from "../assets/svgIcons/SuccessIcon";
import AppOutlet from "../components/AppOutlet";
import { useLocation } from "react-router-dom";

const EmailInvitation = () => {
  const { state } = useLocation();
  const email = state?.email;
  const heading = state?.heading || "Invitation sent";
  const message = state?.message;
  const footnote = state?.footnote || "Didn't receive the email? Check your spam folder.";

  let displayMessage;
  if (message) {
    displayMessage = email ? <>{message} <strong>{email}</strong>.</> : message;
  } else {
    displayMessage = email
      ? <>We've sent a verification email to <strong>{email}</strong>. Please check your inbox and follow the instructions to complete your registration.</>
      : "We've sent a verification email. Please check your inbox and follow the instructions to complete your registration.";
  }

  return (
    <AppOutlet>
      <div className="p-md-5 mt-2 pt-5">
        <div className="d-flex align-items-center flex-column justify-content-center p-2 p-md-5 m-2">
          <StyledText color="primary">
            <SuccessIcon className="px-4 px-md-0" />
          </StyledText>

          <StyledText
            $fontSize="1.1rem"
            $fontWeight="600"
            className="my-4 mt-md-5"
          >
            {heading}
          </StyledText>
          <StyledText
            $fontSize="0.9rem"
            className="mb-3 mb-md-4 text-center"
            color="textColor"
          >
            {displayMessage}
          </StyledText>
        </div>
      </div>
      <StyledText $fontSize="0.85rem" color="textColor" className="ms-auto text-danger">
        {footnote}
      </StyledText>
    </AppOutlet>
  );
};

export default EmailInvitation;
